/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './tabs-extended.scss';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import CDSTab from '@carbon/web-components/es/components/tabs/tab.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * A tab within a tabbed layout.
 *
 * @element c4d-tab
 */
@customElement(`${c4dPrefix}-tab`)
class C4DTab extends StableSelectorMixin(CDSTab) {
  static get stableSelector() {
    return `${c4dPrefix}--tab`;
  }

  /**
   * An event that fires whenever the tab's selected state changes.
   */
  static get eventTabSelected() {
    return `${c4dPrefix}-tab-selected`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DTab;
